import React from "react"
import { Dialog, FlatButton, CircularProgress } from "material-ui"
import strings from "../../../localization/strings"
import { IPunchSetDocument, IQuestion, IRecord, ITimecardEmployee } from "../../../models"
import * as timeHelper from "../../../helpers/timeHelper"
import moment from "moment"
import * as api from "../../../api"
import { grey800 } from "material-ui/styles/colors"
import PunchQuestionAnswerDetailContent from "./PunchQuestionAnswerDetailContent"
interface IProps {
    punchSet: IPunchSetDocument
    user: ITimecardEmployee
    handleClose(): void
}
interface IState {
    loading: boolean
    questions: IQuestion[]
    failurePunchIn: IRecord,
    failurePunchOut: IRecord
}

export default class PunchSetQuestionPreventExceptionDetailDialog extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            questions: [],
            failurePunchIn: null,
            failurePunchOut: null,
        }
    }

    componentDidMount() {
        Promise.all([
            this.props.punchSet.PreQuestionIds && this.props.punchSet.PreQuestionIds.length ?
                api.getPreQuestions(this.props.punchSet.AccountId, this.props.punchSet.PreQuestionGUIds[0]) :
                api.getQuestionByQuestionGUID(this.props.punchSet.PreQuestionGUIds[0]),
            this.props.punchSet.PunchInId &&
            api.getPunchDetail(this.props.punchSet.PunchInId),
            this.props.punchSet.PunchOutId &&
            api.getPunchDetail(this.props.punchSet.PunchOutId)
        ])
            .then(res =>
                this.setState({
                    loading: false,
                    questions: res[0].data.Questions,
                    failurePunchIn: res[1] ? res[1].data : null,
                    failurePunchOut: res[2] ? res[2].data : null,
                })
            )
    }

    render() {
        const imageS3Url = this.state.loading ?
            null :
            this.state.failurePunchIn && this.state.failurePunchIn.Punch.ImageS3Url ?
                this.state.failurePunchIn.Punch.ImageS3Url :
                this.state.failurePunchOut && this.state.failurePunchOut.Punch.ImageS3Url ?
                    this.state.failurePunchOut.Punch.ImageS3Url :
                    this.props.user.ProfileImageS3Url
        return (
            <Dialog
                open
                autoScrollBodyContent
                title={strings.formatString(strings.Punch_Questions_for_x, moment(timeHelper.keepConvertUTCToLocal(this.props.punchSet.RoundingRuleId ? this.props.punchSet.RoundedPunchInTimeLocal : this.props.punchSet.PunchInTimeLocal)).format("hh:mma MM/DD/YYYY"))}
                actions={< FlatButton label={strings.OK} primary onTouchTap={this.props.handleClose} />}
                bodyStyle={{ color: grey800 }}
            >
                {this.state.loading ?
                    <div className="spinner" style={{ paddingBottom: "2em" }}>
                        <CircularProgress />
                    </div> :
                    <PunchQuestionAnswerDetailContent
                        imageS3Url={imageS3Url}
                        questions={this.state.questions}
                        btn1Ids={[...(this.state.failurePunchIn && this.state.failurePunchIn.Punch.Btn1Ids || []), ...(this.state.failurePunchOut && this.state.failurePunchOut.Punch.Btn1Ids || [])]}
                        btn2Ids={[...(this.state.failurePunchIn && this.state.failurePunchIn.Punch.Btn2Ids || []), ...(this.state.failurePunchOut && this.state.failurePunchOut.Punch.Btn2Ids || [])]}
                    />
                }
            </Dialog >
        )
    }
}

